import React, { useEffect, useState } from "react";
import { useFirebase } from "../firebase/useFirebase";
import { useAppContext } from "../../context/useAppContext";
import { useAuth } from "../useAuth";

export const usePermissions = () => {
  const { user } = useAuth();
  const { getDocData: getUser, data: userData } = useFirebase();
  const { getDocData: getRole, data: roleData } = useFirebase();
  const { updateContext } = useAppContext();
  const [complete, setComplete] = useState(false);

  // get current user
  useEffect(() => {
    const uid = user?.uid;
    if (uid) {
      getUser(`users/${uid}`);
    }
  }, [user]);

  //  get user role data
  useEffect(() => {
    const role = userData?.role;
    if (role) {
      getRole(`admin/configurables/roles/${role}`).then(() =>
        setComplete(true)
      );
    }
  }, [userData]);

  // save role permissions
  useEffect(() => {
    const permissions = roleData?.permissions;
    if (permissions?.length > 0) {
      updateContext("permissions", permissions);
    }
  }, [roleData]);

  return { complete };
};
